import { camelCase } from 'lodash-es';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import BooksFormErrorMessage from '../../../../components/books/model1/forms/BooksFormErrorMessage';
import * as IBooks from '../../../../interfaces/merchants/resources/books';

type InnerProps = { name: string } & InjectedIntlProps;

const BlankMessage: React.SFC<InnerProps> = ({ intl, name }) => (
  <BooksFormErrorMessage>
    {intl.formatMessage({
      id: `books.errors.${name}.blank`,
      defaultMessage: intl.formatMessage({ id: 'books.errors.blank' }),
    })}
  </BooksFormErrorMessage>
);

const TakenMessage: React.SFC<InnerProps> = ({ intl, name }) => (
  <BooksFormErrorMessage>
    {intl.formatMessage({
      id: `books.errors.${name}.taken`,
      defaultMessage: intl.formatMessage({ id: 'books.errors.taken' }),
    })}
  </BooksFormErrorMessage>
);

const InvalidMessage: React.SFC<InnerProps> = ({ intl, name }) => (
  <BooksFormErrorMessage>
    {intl.formatMessage({
      id: `books.errors.${name}.invalid`,
      defaultMessage: intl.formatMessage({
        id: 'books.errors.invalid',
      }),
    })}
  </BooksFormErrorMessage>
);

const InvalidDomainMessage: React.SFC<InnerProps> = ({ intl, name }) => (
  <BooksFormErrorMessage>
    {intl.formatMessage({
      id: `books.errors.${name}.invalidDomain`,
      defaultMessage: intl.formatMessage({
        id: 'books.errors.invalidDomain',
      }),
    })}
  </BooksFormErrorMessage>
);

const ERROR_COMPONENTS: {
  // tslint:disable-next-line:no-any
  [error in IBooks.ErrorType]: React.ComponentClass<Pick<InnerProps, 'name'>>;
} = {
  [IBooks.ErrorType.Blank]: injectIntl(BlankMessage),
  [IBooks.ErrorType.Taken]: injectIntl(TakenMessage),
  [IBooks.ErrorType.Invalid]: injectIntl(InvalidMessage),
  [IBooks.ErrorType.InvalidDomain]: injectIntl(InvalidDomainMessage),
  [IBooks.ErrorType.LoginFailed]: injectIntl(InvalidMessage),
};

const isCustomerField = (f: FieldSource): f is IBooks.CustomerField =>
  'name' in f;
const isSurvey = (f: FieldSource): f is IBooks.Survey => 'question' in f;
const isQuestionnaire = (f: FieldSource): f is IBooks.Questionnaire =>
  'type' in f;

const toName = (fieldSource: FieldSource): string => {
  if (isCustomerField(fieldSource)) {
    return camelCase(fieldSource.name);
  }
  if (isSurvey(fieldSource)) {
    return 'survey';
  }
  if (isQuestionnaire(fieldSource)) {
    return fieldSource.type;
  }
  return '';
};

type FieldSource = IBooks.CustomerField | IBooks.Survey | IBooks.Questionnaire;
interface Props {
  fieldSource: FieldSource;
}

class InputUserInfoErrorMessage extends React.Component<Props> {
  public render() {
    const { fieldSource } = this.props;
    if (!fieldSource.errors) {
      return null;
    }
    if (fieldSource.errors.length === 0) {
      return null;
    }
    return fieldSource.errors.map((error, index) => {
      const Component = ERROR_COMPONENTS[error];
      const name = toName(fieldSource);
      return <Component key={index} name={name} />;
    });
  }
}

export default InputUserInfoErrorMessage;
